import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import DiscordIcon from '../components/DiscordIcon';
import { ExternalLink } from 'lucide-react';

const Login = () => {
  const { login, error } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat py-12 px-4 sm:px-6 lg:px-8 relative">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-60"
        style={{ backgroundImage: 'url(https://i.ibb.co/nsR3vLRB/decades-wallpaper.png)' }}
      />
      
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gray-900/40" />
      
      <div className="max-w-md w-full space-y-8 relative z-10">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            Sign in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-300">
            Access your Blood on the Clocktower events
          </p>
        </div>
        
        <div className="bg-white/5 backdrop-blur-md border border-white/20 rounded-xl p-8 shadow-2xl">
          <div className="text-center">
            <h3 className="text-lg font-medium text-white mb-4">
              Sign in to your account
            </h3>
            <p className="text-sm text-gray-300 mb-6">
              Connect with your Discord account to access our event management system.
            </p>
            
            {error && (
              <div className="mb-4 p-3 bg-red-500/20 border border-red-400/30 rounded-lg">
                <p className="text-sm text-red-200">{error}</p>
              </div>
            )}
            
            <button
              onClick={login}
              className="w-full flex items-center justify-center space-x-3 bg-[#5865F2] hover:bg-[#4752C4] text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5865F2] shadow-lg"
            >
              <DiscordIcon size={20} />
              <span>Continue with Discord</span>
            </button>
            
            <div className="mt-6 text-xs text-gray-400">
              <p>You must be a member of the Decades Discord server with the required role to access this application.</p>
            </div>
          </div>
        </div>
        
        {/* Learn More Section */}
        <div className="text-center">
          <div className="bg-white/5 backdrop-blur-md border border-white/20 rounded-xl p-6">
            <h4 className="text-lg font-medium text-white mb-2">
              New to Decades?
            </h4>
            <p className="text-sm text-gray-300 mb-4">
              Join our Blood on the Clocktower community and start playing with us!
            </p>
            <a
              href="https://whydecades.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-primary-600 hover:bg-primary-700 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 shadow-lg"
            >
              <span>Learn More & Join Us</span>
              <ExternalLink size={16} />
            </a>
          </div>
        </div>
        
        <div className="text-center">
          <p className="text-xs text-gray-400">
            Blood on the Clocktower is a social deduction game by The Pandemonium Institute
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login; 